module.exports = __webpack_public_path__ + "img/logo.db6906b3.png";